export default "/assets/track.svg";